/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Popularcategories1Inputs */

const he_home_popularcategories1 = /** @type {(inputs: Home_Popularcategories1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`קטגוריות פופולריות`)
};

const en_home_popularcategories1 = /** @type {(inputs: Home_Popularcategories1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Popular Categories`)
};

/**
* | output |
* | --- |
* | "Popular Categories" |
*
* @param {Home_Popularcategories1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const home_popularcategories1 = /** @type {((inputs?: Home_Popularcategories1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Popularcategories1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_home_popularcategories1(inputs)
	return en_home_popularcategories1(inputs)
});
export { home_popularcategories1 as "home_popularCategories" }